import { getGuidsFromServer, getQuerystringParameters } from '../helpers/utility';
import { apimCall } from '../helpers/api';
import { showBanner } from '../helpers/MessageUtility';
import { RootState } from '../gf-types';
import { GoFormzServices } from '../AppSettings';

export const REPORTVIEW_DESIGNER_CLEAR = 'REPORTVIEW_DESIGNER_CLEAR';
export const REPORTVIEW_DESIGNER_CREATE_INIT = 'REPORTVIEW_DESIGNER_CREATE_INIT';
export const REPORTVIEW_DESIGNER_EDIT_INIT = 'REPORTVIEW_DESIGNER_EDIT_INIT';
export const REPORTVIEW_DESIGNER_EDIT_INIT_FAILURE = 'REPORTVIEW_DESIGNER_EDIT_INIT_FAILURE';
export const REPORTVIEW_DESIGNER_UPDATECOLUMNFIELD = 'REPORTVIEW_DESIGNER_UPDATECOLUMNFIELD';
export const REPORTVIEW_DESIGNER_ADDCOLUMN = 'REPORTVIEW_DESIGNER_ADDCOLUMN';
export const REPORTVIEW_DESIGNER_REMOVECOLUMN = 'REPORTVIEW_DESIGNER_REMOVECOLUMN';
export const REPORTVIEW_DESIGNER_UPDATECOLUMNSORTORDER = 'REPORTVIEW_DESIGNER_UPDATECOLUMNSORTORDER';
export const REPORTVIEW_DESIGNER_ADDTEMPLATE = 'REPORTVIEW_DESIGNER_ADDTEMPLATE';
export const REPORTVIEW_DESIGNER_REMOVETEMPLATE = 'REPORTVIEW_DESIGNER_REMOVETEMPLATE';
export const REPORTVIEW_DESIGNER_UPDATECOLUMNNAME = 'REPORTVIEW_DESIGNER_UPDATECOLUMNNAME';
export const REPORTVIEW_DESIGNER_SAVE_REQUEST = 'REPORTVIEW_DESIGNER_SAVE_REQUEST';
export const REPORTVIEW_DESIGNER_SAVE_SUCCESS = 'REPORTVIEW_DESIGNER_SAVE_SUCCESS';
export const REPORTVIEW_DESIGNER_UPDATENAME = 'REPORTVIEW_DESIGNER_UPDATENAME';
export const REPORTVIEW_DESIGNER_UPDATEMETACOLUMNNAME = 'REPORTVIEW_DESIGNER_UPDATEMETACOLUMNNAME';
export const REPORTVIEW_DESIGNER_COLUMNMOVELEFT = 'REPORTVIEW_DESIGNER_COLUMNMOVELEFT';
export const REPORTVIEW_DESIGNER_COLUMNMOVERIGHT = 'REPORTVIEW_DESIGNER_COLUMNMOVERIGHT';
export const REPORTVIEW_DESIGNER_CHANGEFILTERS = 'REPORTVIEW_DESIGNER_CHANGEFILTERS';
export const REPORTVIEW_DESIGNER_SETSORT = 'REPORTVIEW_DESIGNER_SETSORT';
export const REPORTVIEW_DESIGNER_REORDERCOLUMSALPHABETICALLY = 'REPORTVIEW_DESIGNER_REORDERCOLUMSALPHABETICALLY';

export const clear = () => ({
  type: REPORTVIEW_DESIGNER_CLEAR
});

export const getReportInitFailure = (error) => ({
  type: REPORTVIEW_DESIGNER_EDIT_INIT_FAILURE,
  payload: {
    error: {
      message: error
    },
    isFetching: false
  }
});

export const init = (initialReport) => async (dispatch) => {
  const params = getQuerystringParameters();
  getGuidsFromServer(1000);

  if (params.id) {
    try {
      const response = await apimCall(GoFormzServices.TemplateService, `/reportviews/${params.id}`);
      dispatch({
        type: REPORTVIEW_DESIGNER_EDIT_INIT,
        payload: {
          reportView: response.data
        }
      });
    } catch (err) {
      dispatch(getReportInitFailure(err));
    }
  } else {
    dispatch({
      type: REPORTVIEW_DESIGNER_CREATE_INIT,
      payload: initialReport ? { reportView: initialReport, defaultFilterOpened: true } : {}
    });
  }
};

export const save = () => async (dispatch, getState: () => RootState) => {
  dispatch({
    type: REPORTVIEW_DESIGNER_SAVE_REQUEST
  });

  const state: RootState = getState();
  const { reportView } = state.reports;
  const response = await apimCall(GoFormzServices.TemplateService, '/reportviews', 'PUT', reportView);
  const id = response.data;

  showBanner('Report Saved');

  dispatch({
    type: REPORTVIEW_DESIGNER_SAVE_SUCCESS,
    payload: {
      reportViewId: id
    }
  });
};

export const updateTemplateColumnField = (templateId, columnId, fieldId, fieldName, fieldType, fieldColumnIndex, isTableRowNumber) => ({
  type: REPORTVIEW_DESIGNER_UPDATECOLUMNFIELD,
  payload: { templateId, columnId, fieldId, fieldName, fieldType, fieldColumnIndex, isTableRowNumber }
});

export const addColumn = () => ({
  type: REPORTVIEW_DESIGNER_ADDCOLUMN,
  payload: {}
});

export const removeColumn = (columnId) => ({
  type: REPORTVIEW_DESIGNER_REMOVECOLUMN,
  payload: { columnId }
});

export const moveColumnLeft = (columnId) => ({
  type: REPORTVIEW_DESIGNER_COLUMNMOVELEFT,
  payload: { columnId }
});

export const moveColumnRight = (columnId) => ({
  type: REPORTVIEW_DESIGNER_COLUMNMOVERIGHT,
  payload: { columnId }
});

export const updateColumnSortOrder = (columnId, sortOrder) => ({
  type: REPORTVIEW_DESIGNER_UPDATECOLUMNSORTORDER,
  payload: { columnId, sortOrder }
});

export const reOrderColumnsAlphabetically = () => ({
  type: REPORTVIEW_DESIGNER_REORDERCOLUMSALPHABETICALLY
});

export const updateColumnName = (columnId, name) => ({
  type: REPORTVIEW_DESIGNER_UPDATECOLUMNNAME,
  payload: { columnId, name }
});

export const updateMetaColumnName = (columnId, metaColumnName) => ({
  type: REPORTVIEW_DESIGNER_UPDATEMETACOLUMNNAME,
  payload: { columnId, metaColumnName }
});

export const addTemplate = (templateId) => ({
  type: REPORTVIEW_DESIGNER_ADDTEMPLATE,
  payload: { templateId }
});

export const removeTemplate = (templateId) => ({
  type: REPORTVIEW_DESIGNER_REMOVETEMPLATE,
  payload: { templateId }
});

export const updateName = (name) => ({
  type: REPORTVIEW_DESIGNER_UPDATENAME,
  payload: { name }
});

export const changeFilters = (filters) => (dispatch) => {
  dispatch({
    type: REPORTVIEW_DESIGNER_CHANGEFILTERS,
    payload: { filters }
  });
};

export const setSort = (sort) => ({
  type: REPORTVIEW_DESIGNER_SETSORT,
  payload: { sort }
});
